import { FC } from 'react'

import {
  GreyGrey80,
  Primary13Regular,
  SimpleModal,
  Text
} from '@sequencehq/core-components'

import {
  MODAL_BASE_PROPS,
  PUBLISH_MODAL_COPY
} from './PublishQuoteModalV2.constants'

/**
 * The simulation ran this quote through the live approval workflow and it came
 * out rejected, so there's nothing to confirm - only something to explain. No
 * submit button, because publishing from here would go straight to a workflow
 * that turns it down.
 */
export const ModalAutoRejected: FC<{ onClose: () => void }> = ({ onClose }) => (
  <SimpleModal
    {...MODAL_BASE_PROPS}
    onClose={onClose}
    title={PUBLISH_MODAL_COPY.autoRejected.title}
    showSubmitButton={false}
    cancelButtonText={PUBLISH_MODAL_COPY.autoRejected.closeButton}
    data-testid="modal.publishQuote.autoRejected"
  >
    <Text
      {...Primary13Regular}
      color={GreyGrey80}
      data-testid="modal.publishQuote.autoRejected.body"
    >
      {PUBLISH_MODAL_COPY.autoRejected.body}
    </Text>
  </SimpleModal>
)
